import { ContactId } from '@api';
import classnames from 'classnames';
import * as React from 'react';
import { reduxForm } from 'redux-form';
import { sendAdobeAnalyticsEvent } from 'src/js/actions/AdobeAnalyticActions';
import { AdobeAnalyticsFormAbandonTrackService, sendLoginEvent } from 'src/js/services/AdobeAnalyticsService';
import { showFormValidation, showSyncErrors } from '../../actions/Actions';
import CheckoutService from '../../services/CheckoutService';
import { COMPANY_ADD_FORM_NAME, CONTACT_ADD_FORM_NAME, Values } from './actions/Actions';
import { validateCompany } from './actions/Validations';

import { CompanyAdd } from './components/CompanyAdd';


class CompanyAddForm extends React.Component<any, any> {
  componentDidMount() {
    AdobeAnalyticsFormAbandonTrackService.attachFormAbandonClicksTrack(this.props.form, this.props.dispatch)
  }

  componentWillUnmount() {
    AdobeAnalyticsFormAbandonTrackService.detachFormAbandonClicksTrack()
  }

  onSubmitPress = (values) => {
    const { fieldset } = this.props;
    return CheckoutService.createOrGetContact({...values, company: true}, fieldset)
  }

  render() {
    const {handleSubmit, onCancel, pristine, submitting, fetching} = this.props;

    return (
      <div>
        <h2>Add a business</h2>
        <form
          onSubmit={handleSubmit(this.onSubmitPress)}
          className={classnames({submitting: submitting || fetching})}
          id="contactEditorForm"
        >
          <CompanyAdd/>
          <div className="form-controls flex">
            <span>
              {onCancel &&
              <a
                href="#"
                type="button"
                onClick={onCancel}
              > Cancel
              </a>
              }
            </span>

            <input
              value="OK"
              className="btn btn-primary"
              name="submitContact"
              type="submit"
              disabled={pristine || submitting}
            />

          </div>
        </form>
      </div>
    );
  }
}

const Form = reduxForm({
  form: COMPANY_ADD_FORM_NAME,
  validate: validateCompany,
  onSubmitSuccess: (result, dispatch, props: any) => {
    dispatch(props.onSuccess(result as ContactId, props.values as Values));
    dispatch(sendAdobeAnalyticsEvent('your details – step 1'));
    sendLoginEvent(
      result.newContact ? 'createAccountSuccessful' : 'loginSuccess',
      props.values.email,
      result.id
    )
  },
  onSubmitFail: (errors, dispatch, submitError, props) => {
    if (errors && !submitError) {
      dispatch(showSyncErrors(errors));
    } else {
      dispatch(showFormValidation(submitError, CONTACT_ADD_FORM_NAME));
    }
    sendLoginEvent(
      'loginFail',
      props.values.email,
      'NA'
    )
  },
})(CompanyAddForm);


export default Form;
